import errorManager from '@/rollbar.js';

const confirmModal = (target) => {
  let url = target.data('url');
  const message = target.data('message');
  if (!confirm(message)) {
    url = Utils.addGetParam(url, 'no_copy_targets', true);
    if (!target.data('at-least-one')) {
      url = Utils.addGetParam(url, 'no_copy', true);
    }
  }
  window.location.replace(url);
};

const setListener = (selector) => {
  selector.on('click', (e) => {
    confirmModal($(e.currentTarget));
  });
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestValutationCopy = {
  init: init,
};
